module.exports = __webpack_public_path__ + "static/media/Ломакина Е., Деревянко О. (КФА).643c2212.pdf";